module.exports = __webpack_public_path__ + "media/images/lb/614-029f0be4d83876039ad5eb7a91732a69.svg";